import { fetchAuthSession, signInWithRedirect, signOut, JWT } from "aws-amplify/auth";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CustomOAuthState } from "../types/CustomOAuthState";

export type IdTokenClaims = JWT["payload"];

export class AuthUtils {
  /**
   * Forces a refresh of the current session so that updated attributes/groups are picked up.
   */
  public static async refreshCurrentSession() {
    return fetchAuthSession({ forceRefresh: true });
  }

  /**
   * Returns the claims of the current id token, or undefined when the user is not signed-in.
   */
  public static async getIdTokenClaims(): Promise<IdTokenClaims | undefined> {
    const { tokens } = await fetchAuthSession();
    return tokens?.idToken?.payload;
  }

  /**
   * Signs in the user.
   */
  public static async signIn() {
    const customOAuthState: CustomOAuthState = {
      initialPagePath: window.location.pathname
    };
    await signInWithRedirect({
      customState: JSON.stringify(customOAuthState)
    });
  }

  /**
   * Signs out the user. A password sign-in can inherit a hosted UI session cookie left behind by a
   * previous user of the same browser, and Amplify only visits the hosted UI logout endpoint for the
   * sessions it considers OAuth ones. Marking every session as an OAuth one clears that cookie and
   * makes the navigation back to the configured sign-out URL uniform.
   */
  public static async signOut() {
    await cognitoUserPoolsTokenProvider.tokenOrchestrator.setOAuthMetadata({ oauthSignIn: true });
    await signOut();
  }
}
